const isWindowReadyToFocus = () => Promise.resolve();

export default isWindowReadyToFocus;
